module.exports = __webpack_public_path__ + "media/kommissar_1.1a_2.5eeca8ff.mp3";